import React from 'react'
import { Typography, withStyles } from '@material-ui/core'
import styles from './styles'

import { useSelector } from 'react-redux'
import { addCustomDomainAction } from 'src/reducers/domain/action'
import { CoreButton, CoreTextField } from 'src/components/core'
const CnameView = props => {
  const { entity, dispatch, classes } = props
  const [domain, setDomain] = React.useState('')
  const collectionSettings = useSelector(
    state => state.courseCollectionList.collectionSettings,
  )
  const customDomain = useSelector(state => state.domain.list)

  let customDomainList = customDomain && customDomain.results
  customDomainList =
    customDomainList &&
    customDomainList.filter(
      x => x.defaultCollectionDto && x.defaultCollectionDto.id == entity.id,
    )
  const cname =
    collectionSettings.domain == null
      ? 'custom.minicoursegenerator.com'
      : customDomainList.find(
          x => x.defaultCollectionDto.id == collectionSettings.domain,
        ) != null
      ? customDomainList.find(
          x => x.defaultCollectionDto.id == collectionSettings.domain,
        )[0].domain
      : 'custom.minicoursegenerator.com'

  const handleAddDomain = () => {
    const data = {
      domain: domain,
      defaultCollectionId: entity.id,
      defaultCourseId: null,
      type: 'Collection',
    }
    dispatch(addCustomDomainAction(data, response => {}))
  }

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          gap: 16,
        }}
      >
        <CoreTextField
          defaultValue="app.your.domain.com"
          placeholder="app.your.domain.com"
          label="CNAME"
          size="medium"
          disabled
          fullWidth
        />

        <CoreTextField
          value={domain}
          onChange={e => setDomain(e.target.value)}
          placeholder="app.your.domain.com"
          label="Subdomain"
          size="medium"
          fullWidth
        />
      </div>
      <div className={classes.customDomain__buttonDiv}>
        <CoreButton
          variant="contained"
          color="success"
          size="medium"
          disabled={domain == ''}
          onClick={() => handleAddDomain()}
        >
          Add Subdomain
        </CoreButton>
      </div>
    </div>
  )
}

export default withStyles(styles)(CnameView)
